import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/shadcn/button'

interface Props {
  disabledNew: boolean
  onNewAutomation: () => void
}

export function AutomationsHeader({ disabledNew, onNewAutomation }: Props) {
  return (
    <header className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Automations</h1>
        <p className="text-muted-foreground max-w-xl text-sm">
          One weekly schedule for your whole brand. Cassi drafts each post and emails you to review.
        </p>
      </div>
      <Button
        variant="primary"
        onClick={onNewAutomation}
        disabled={disabledNew}
        className="w-full shrink-0 sm:w-auto">
        <Plus className="h-4 w-4" />
        New automation
      </Button>
    </header>
  )
}
